import { SidebarLink } from "../components/sidebar/sidebarlink";
import { PermissionUrlService } from "./../../shared/services/permissions.service";
const widgetPermission = new PermissionUrlService();

export const SIDEBARLINKS: SidebarLink[] = [
  {
    icon_fa: '',
    image: "../../../assets/images/SF.svg",
    imageActive: "../../../assets/images/SF.svg",
    text: "MENU.OVERALL_STATUS",
    route: "/overall-status",
    permissions: [...widgetPermission.OVERALL_STATUS_PAGE],
    show: true
  },
  {
    //icon: "fa-chart-line",
    icon_fa: '',
    image: "../../../assets/images/PD.svg",
    imageActive: "../../../assets/images/PD-s.svg",
    text: "MENU.OVERALL_PERFORMANCE",
    route: "/performance",
    permissions: [
      ...widgetPermission.OVERALL_PERFORMANCE_TAB_DELHIVERY,
      ...widgetPermission.OVERALL_PERFORMANCE_TAB_INWARD,
      ...widgetPermission.OVERALL_PERFORMANCE_TAB_TRANSFER,
      ...widgetPermission.OVERALL_PERFORMANCE_TAB_TRANSFER
    ],
    show: true
  },
  {
    //icon: "fa-warehouse",
    icon_fa: '',
    image: "../../../assets/images/WP.svg",
    imageActive: "../../../assets/images/WP-s.svg",
    text: "MENU.WAREHOUSE_PERFORMANCE",
    route: "/warehousedashboard",
    permissions: [
      ...widgetPermission.WAREHOUSE_PAGE,

    ],
    show: true
  },
  {
    //icon: "fa-truck",
    icon_fa: '',
    image: "../../../assets/images/TP.svg",
    imageActive: "../../../assets/images/TP-s.svg",
    text: "MENU.TRANSPORTATION_PERFORMANCE",
    route: "/transportationdashboard",
    permissions: [...widgetPermission.TRANSPORTATION_PAGE],
    show: true
  },
  {
    //icon: "fa-boxes",
    icon_fa: '',
    image: "../../../assets/images/ID.svg",
    imageActive: "../../../assets/images/ID-s.svg",
    text: "MENU.INVENTORY_DETAILS",
    route: "/inventorydetailsdashboard",
    permissions: [...widgetPermission.INVENTORY_DETAIL_PAGE],
    show: true
  },
  {
    //icon: "fa-truck-moving",
    icon_fa: '',
    image: "../../../assets/images/MD.svg",
    imageActive: "../../../assets/images/MD-s.svg",
    text: "MENU.ORDER_DETAILS",
    route: "/movementdetailsdashboard",
    permissions: [...widgetPermission.MOVEMENT_DETAIL_PAGE],
    show: true
  },
  {
    icon_fa: 'fa-chart-line',
    image: "../../../assets/images/SF.svg",
    imageActive: "../../../assets/images/SF.svg",
    text: "MENU.SALESFORECAST",
    route: "/sales-forecast",
    permissions: [...widgetPermission.SALESFORECAST_PERMISSION_PAGE],
    show: true
  },
  {
    icon_fa: 'fa-people-carry',
    image: "../../../assets/images/SF.svg",
    imageActive: "../../../assets/images/SF.svg",
    text: "MENU.PICKUP_REQUEST_MANAGEMENT",
    route: "/pickup-request",
    permissions: [...widgetPermission.PICKUP_PAGE_PERMISSIONS],
    show: true
  },
  {
    icon_fa: 'fa-users-cog',
    image: "../../../assets/images/SF.svg",
    imageActive: "../../../assets/images/SF.svg",
    text: "MENU.USER_MANAGEMENT",
    route: "/user-management",
    permissions: [...widgetPermission.USER_MANAGEMENT],
    show: false
  },
  {
    icon_fa: 'fa-user-tie',
    image: "../../../assets/images/SF.svg",
    imageActive: "../../../assets/images/SF.svg",
    text: "MENU.CLIENT_MANAGEMENT",
    route: "/client-management",
    permissions: [...widgetPermission.CLIENT_MANAGEMENT],
    show: true
  },
  {
    icon_fa: 'fa-file-download',
    image: "../../../assets/images/PD.svg",
    imageActive: "../../../assets/images/PD-s.svg",
    text: "MENU.REPORT_DOWNLOAD",
    route: "/download-reports",
    permissions: [...widgetPermission.DOWNLOAD_REPORTS],
    show: true
  }
  // {
  //   image: "../../../assets/images/SF.svg",
  //   imageActive: "../../../assets/images/SF.svg",
  //   text: "MENU.FRESH_DESK",
  //   route: "/fresh-desk",
  //   permissions: [...widgetPermission.FRESH_DESK_PERMISSIONS],
  //   show: true
  // }
];
